import { NavigationGuard } from "vue-router";
import { store } from "@/store";

export const authGuard: NavigationGuard = (to, from, next) => {
    if (!store.getters["app/isAuthenticated"]) {
        store.dispatch("app/login");
    } else {
        next();
    }
};
